export default {
    data() {
        return {
            baseUrl: this.$global.baseUrl,
            searchContent: "",
            commonUseChecked: false,
            tableData: [],
            total: 0,
            pageIndex: 1,
            pageSize: 12,
            dialogManageShow: false,
            manageForm: {},
            multipleSelection: [],
            postList: [],
            dialogImageShow: false,
            certificateImage: null
        }
    },
    mounted: function() {
        this.query();
    },
    methods: {
        clickEvent: function(id, data) {
            switch (id) {
                case "search": //搜索
                    this.pageIndex = 1;
                    this.query();
                    break;
                case "add": //添加
                    this.queryPost();
                    this.manageForm = {
                        isCommonUse: false,
                        fileList: []
                    };
                    this.dialogManageShow = true;
                    break;
                case "edit": //编辑
                    if (this.multipleSelection.length != 1) {
                        this.$message.closeAll();
                        this.$message.warning("请选择一项进行修改");
                        return;
                    }
                    this.queryPost();
                    this.manageForm = Object.assign({}, this.multipleSelection[0]);
                    this.dialogManageShow = true;
                    break;
                case "manageConfirm": //确定
                    this.$refs['manageForm'].validate((valid) => {
                        if (valid) {
                            if (this.manageForm.fileInfoId == null || this.manageForm.fileInfoId == '') {
                                this.$message.closeAll();
                                this.$message.warning("请上传证书模板文件");
                                return;
                            }
                            this.saveOrUpdate();
                        } else {
                            return false;
                        }
                    });
                    break;
                case "delete": //删除
                    if (this.multipleSelection.length == 0) {
                        this.$message.closeAll();
                        this.$message.warning("请至少选择一项进行删除");
                        return;
                    }
                    this.$confirm('此操作将删除所选中的证书模板数据, 是否继续?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.delete();
                    }).catch(() => {});
                    break;
                case "watchCertificateImage": //查看证书文件
                    this.certificateImage = data.fileInfoPath;
                    this.dialogImageShow = true;
                    break;
                default:
                    break;
            }
        },

        /**
         * 格式化日期
         */
        formatDate: function(str) {
            return str.substring(0, 10)
        },

        /**
         * table选中事件
         * @param {*} val 
         */
        tableColumnCheckEvent: function(val) {
            this.multipleSelection = val;
        },

        /**
         * 文件上传之前处理
         * @param {*} file 
         */
        handleBeforeUpload: function(file) {
            if (file.type.indexOf("jpg") == -1 && file.type.indexOf('png') == -1 && file.type.indexOf('jpeg') == -1) {
                this.manageForm.fileList = [];
                this.$message.closeAll();
                this.$message.error("只能上传图片格式文件");
                return false;
            }
        },

        /**
         * 上传失败
         * @param {*} files 
         * @param {*} fileList 
         */
        handleError: function(err, file, fileList) {
            this.$message.closeAll();
            this.$message.error("上传失败");
        },

        /**
         * 上传成功
         * @param {*} response 
         * @param {*} file 
         * @param {*} fileList 
         */
        handleSuccess: function(response, file, fileList) {
            if (response.success) {
                this.manageForm.fileList = [];
                this.manageForm.fileInfoId = response.data.id;
                this.$set(this.manageForm, "fileInfoPath", response.data.path);
            } else {
                this.$message.closeAll();
                this.$message.error(response.message);
            }
        },

        /**
         * 翻页
         * @param {*} val 
         */
        handlePageChange: function(val) {
            this.pageIndex = val;
            this.query();
        },

        /**
         * 查询岗位列表
         */
        queryPost: function() {
            this.$post({
                url: 'org/query',
                params: {
                    orgType: 3
                }
            }).then(response => {
                var postList = new Array;
                response.data.forEach(elem => {
                    var count = 0;
                    postList.forEach(item => {
                        if (elem.name == item.name) {
                            count += 1;
                        }
                    });
                    if (count == 0)
                        postList.push(elem);
                });
                this.postList = postList;
            });
        },

        /**
         * 新增或修改
         */
        saveOrUpdate: function() {
            this.$post({
                url: "/certificate_template/saveOrUpdate",
                params: {
                    id: this.manageForm.id,
                    name: this.manageForm.name,
                    code: this.manageForm.code,
                    postName: this.manageForm.postName,
                    fileInfoId: this.manageForm.fileInfoId,
                    isCommon: this.manageForm.isCommonUse
                }
            }).then(res => {
                this.manageForm = {};
                this.dialogManageShow = false;
                this.$message.closeAll();
                this.$message.success("添加成功");
                this.query();
            });
        },

        /**
         * 批量删除
         */
        delete: function() {
            var ids = new Array();
            this.multipleSelection.forEach(elem => {
                ids.push(elem.id);
            });
            this.$post({
                url: "/certificate_template/delete",
                params: {
                    ids: ids
                }
            }).then(res => {
                this.$message.closeAll();
                this.$message.success("删除成功");
                this.query();
            });
        },

        /**
         * 查询
         */
        query: function() {
            this.$post({
                url: 'certificate_template/queryByPage',
                params: {
                    keyWord: this.searchContent,
                    isCommon: this.commonUseChecked ? true : null,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                }
            }, true).then(response => {
                this.total = response.total;
                this.tableData = response.data;
            });
        }
    }
}